import { withStyles } from "@material-ui/core/styles";
import WithCurrency from "./WithCurrency";
import styles from "./styles";

export default withStyles(styles)(WithCurrency);
